import { render, staticRenderFns } from "./Amidan.vue?vue&type=template&id=c335a538&scoped=true&"
import script from "./Amidan.vue?vue&type=script&lang=js&"
export * from "./Amidan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c335a538",
  null
  
)

export default component.exports